import { render, staticRenderFns } from "./AddImgBox.vue?vue&type=template&id=4ffe47d4&"
import script from "./AddImgBox.vue?vue&type=script&lang=js&"
export * from "./AddImgBox.vue?vue&type=script&lang=js&"
import style0 from "./AddImgBox.vue?vue&type=style&index=0&id=4ffe47d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports